import axiosInstance from '../Config/axios';
import axios from 'axios';

import {
  LOGOUT,
  USER_PROFILE,
  UPDATE_USER_PROFILE,
  ACTIVATE_USER,
  DISABLE_USER,
  USER_REFERRAL,
  REMOVE_USER_REFERRAL,
  CHANGE_PASSWORD,
  LIST_USERS,
  WALLET_TRANSACTIONS,
  WALLET_TRANSFER,
  WALLET_BALANCE,
  MTN_RETAIL,
  MTN_BULK,
  MTN_BULK_BILL,
  MTN_ELECTRONIC_BALANCE,
  MTN_CASH,
  MTN_RETAIL_BILL,
  SYRIATEL_RETAIL_RECHARGE,
  SYRIATEL_BULK_RECHARGE,
  SYRIATEL_CASH_RECHARGE,
  SYRIATEL_BILL_PAYMENT,
  SYRIATEL_ELECTRONIC_BALANCE_RECHARGE,
  SERVICES_TRANSACTIONS,
  REPORTS_DASHBOARD,
  REPORTS_QUICK_STATS,
  REPORTS_TRENDING,
  REPORTS_ANALYTICS_FINANCIAL,
  REPORTS_ANALYTICS_USERS,
  REPORTS_ANALYTICS_PERFORMANCE,
  REPORTS_HISTORY,
  ABILI_BALANCE,
  ACTIVE_SERVICES,
  SERVICE_COMMISSIONS,
  API_CONNECTIONS,
  API_CONNECTION_UPDATE,
  SERVICE_COMMISSION_UPDATE,
  SET_WHOLESALE_USER,
  USER_FINANCIAL_STATEMENT,
  ADMIN_SYRIATEL_TRANSACTIONS,
  ADMIN_MTN_TRANSACTIONS,
  ADMIN_ALL_TRANSACTIONS,
  ADMIN_WALLETS,
  ADMIN_TOTAL_BALANCES,
  RETRY_SYRIATEL_TRANSACTION,
  RETRY_MTN_TRANSACTION,
  MAINTENANCE_STATUS,
  MAINTENANCE_MODE
} from "./Api";

// تسجيل الخروج - طلب محمي
export const logoutUser = async () => {
  try {
    // الحصول على refresh token من الجلسة
    const { sessionManager } = await import('../Config/cookies');
    const session = sessionManager.restoreSession();
    const refreshToken = session?.refreshToken;

    if (!refreshToken) {
      return { message: 'تم حذف الجلسة المحلية' };
    }

    const response = await axiosInstance.post(LOGOUT, {
      refresh: refreshToken
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
//////////////////////////////////////////
// الحصول على الملف الشخصي - طلب محمي
export const getUserProfile = async () => {
  const response = await axiosInstance.get(USER_PROFILE);
  return response.data;
};


// تحديث الملف الشخصي - طلب محمي
export const updateUserProfile = async (data) => {
  const response = await axiosInstance.put(UPDATE_USER_PROFILE, data);
  return response.data;
};


// تفعيل المستخدم - طلب محمي 
export const activateUser = async (userId) => {
  const response = await axiosInstance.post(ACTIVATE_USER(userId));
  return response.data;
};

// تعطيل المستخدم - طلب محمي 
export const disableUser = async (userId) => {
  const response = await axiosInstance.post(DISABLE_USER(userId));
  return response.data;
};

// إضافة مرجع للمستخدم - طلب محمي 
export const addUserReferral = async (userId, referralData) => {
  const response = await axiosInstance.post(USER_REFERRAL(userId), referralData);
  return response.data;
};

// إزالة مرجع المستخدم - طلب محمي 
export const removeUserReferral = async (userId) => {
  const response = await axiosInstance.post(REMOVE_USER_REFERRAL(userId));
  return response.data;
};

// تعيين المستخدم كتاجر جملة - طلب محمي
export const setWholesaleUser = async (userId, isWholesale) => {
  const response = await axiosInstance.post(SET_WHOLESALE_USER(userId), { is_wholesale: isWholesale });
  return response.data;
};

// تغيير كلمة المرور - طلب محمي
export const changePassword = async (data) => {
  const response = await axiosInstance.post(CHANGE_PASSWORD, data);
  return response.data;
};

// جلب قائمة المستخدمين - طلب محمي 
export const getUsersList = async (params = {}) => {
  const response = await axiosInstance.get(LIST_USERS, { params });
  const data = response.data;
  // تطبيع الاستجابة إلى شكل موحّد لطبقة العرض
  return {
    users: data.results ?? [],
    total: data.count ?? 0,
    next: data.next ?? null,
    previous: data.previous ?? null,
  };
};

// جلب قائمة تحويلات المحفظة - طلب محمي
export const getTransactionsList = async (params = {}) => {
  const response = await axiosInstance.get(WALLET_TRANSACTIONS, { params });
  const data = response.data;

  // تطبيع الاستجابة إلى شكل موحّد لطبقة العرض
  return {
    transactions: data.results ?? [],
    total: data.count ?? 0,
    next: data.next ?? null,
    previous: data.previous ?? null,
  };
};


// تحويل الرصيد من محفظة لمحفظة - طلب محمي
export const transferWallet = async (data) => {
  const response = await axiosInstance.post(WALLET_TRANSFER, data);
  return response.data;
};


//  Wallet Balance
export const fetchWalletBalance = async () => {
  const response = await axiosInstance.get(WALLET_BALANCE);
  return response.data;
};



//  MTN Retail
export const mtnRetail = async (data) => {
  const response = await axiosInstance.post(MTN_RETAIL, data);
  return response.data;
};

//  MTN Bulk
export const mtnBulk = async (data) => {
  const response = await axiosInstance.post(MTN_BULK, data);
  return response.data;
};

//  MTN Bulk Bill
export const mtnBulkBill = async (data) => {
  const response = await axiosInstance.post(MTN_BULK_BILL, data);
  return response.data;
};

//  MTN Electronic Balance
export const mtnElectronicBalance = async (data) => {
  const response = await axiosInstance.post(MTN_ELECTRONIC_BALANCE, data);
  return response.data;
};

//  MTN Cash
export const mtnCash = async (data) => {
  const response = await axiosInstance.post(MTN_CASH, data);
  return response.data;
};

//  MTN Retail Bill
export const mtnRetailBill = async (data) => {
  const response = await axiosInstance.post(MTN_RETAIL_BILL, data);
  return response.data;
};



//  Syriatel Retail
export const syriatelRetailRecharge = async (data) => {
  const response = await axiosInstance.post(SYRIATEL_RETAIL_RECHARGE, data);
  return response.data;
};

//  Syriatel Bulk
export const syriatelBulkRecharge = async (data) => {
  const response = await axiosInstance.post(SYRIATEL_BULK_RECHARGE, data);
  return response.data;
};

//  Syriatel Cash
export const syriatelCashRecharge = async (data) => {
  const response = await axiosInstance.post(SYRIATEL_CASH_RECHARGE, data);
  return response.data;
};

//  Syriatel Bill
export const syriatelBillPayment = async (data) => {
  const response = await axiosInstance.post(SYRIATEL_BILL_PAYMENT, data);
  return response.data;
};

//  Syriatel Electronic Balance
export const syriatelElectronicBalanceRecharge = async (data) => {
  const response = await axiosInstance.post(SYRIATEL_ELECTRONIC_BALANCE_RECHARGE, data);
  return response.data;
};


//Services Transactions
export const getServicesTransactions = async (params = {}) => {
  const response = await axiosInstance.get(SERVICES_TRANSACTIONS, { params });
  const data = response.data;

  return {
    transactions: data.results ?? [],
    total: data.count ?? 0,
    next: data.next ?? null,
    previous: data.previous ?? null,
  };
};


//  Dashboard Report
export const getReportsDashboard = async (params = {}) => {
  const response = await axiosInstance.get(REPORTS_DASHBOARD, { params });
  return response.data;
};

//  Quick Stats
export const getReportsQuickStats = async (params = {}) => {
  const response = await axiosInstance.get(REPORTS_QUICK_STATS, { params });
  return response.data;
};

//  Trending
export const getReportsTrending = async (params = {}) => {
  const response = await axiosInstance.get(REPORTS_TRENDING, { params });
  return response.data;
};

//  Financial Analytics
export const getReportsAnalyticsFinancial = async (body = {}) => {
  const response = await axiosInstance.post(REPORTS_ANALYTICS_FINANCIAL, body);
  return response.data;
};

//  Users Analytics
export const getReportsAnalyticsUsers = async (body = {}) => {
  const response = await axiosInstance.post(REPORTS_ANALYTICS_USERS, body);
  return response.data;
};

//  Performance Analytics
export const getReportsAnalyticsPerformance = async (body = {}) => {
  const response = await axiosInstance.post(REPORTS_ANALYTICS_PERFORMANCE, body);
  return response.data;
};

//  Reports History 
export const getReportsHistory = async () => {
  const response = await axiosInstance.get(REPORTS_HISTORY);
  return response.data;
};


//Abili Balance
export const fetchAbiliBalance = async () => {
  const response = await axiosInstance.get(ABILI_BALANCE);
  return response.data;
};

//Active Services
export const fetchActiveServices = async () => {
  const response = await axiosInstance.get(ACTIVE_SERVICES);
  return response.data;
};

//User Financial Statement
export const getUserFinancialStatement = async (userId, params = {}) => {
  const response = await axiosInstance.get(USER_FINANCIAL_STATEMENT(userId), { params });
  return response.data;
};

//Service Commissions
export const getServiceCommissions = async (params = {}) => {
  const response = await axiosInstance.get(SERVICE_COMMISSIONS, { params });
  const data = response.data;

  return {
    commissions: data.results ?? [],
    total: data.count ?? 0,
    next: data.next ?? null,
    previous: data.previous ?? null,
  };
};

//API Connections
export const getApiConnections = async (params = {}) => {
  const response = await axiosInstance.get(API_CONNECTIONS, { params });
  const data = response.data;

  return {
    connections: data.results ?? [],
    total: data.count ?? 0,
    next: data.next ?? null,
    previous: data.previous ?? null,
  };
};

//Update API Connection
export const updateApiConnection = async (id, data) => {
  const response = await axiosInstance.post(API_CONNECTION_UPDATE(id), data);
  return response.data;
};

//Update Service Commission
export const updateServiceCommission = async (id, data) => {
  const response = await axiosInstance.post(SERVICE_COMMISSION_UPDATE(id), data);
  return response.data;
};

// Admin Syriatel Transactions
export const getAdminSyriatelTransactions = async (params = {}) => {
  const response = await axiosInstance.get(ADMIN_SYRIATEL_TRANSACTIONS, { params });
  const data = response.data;
  return {
    transactions: data.results ?? [],
    total: data.count ?? 0,
    summary: data.summary ?? {},
    next: data.next ?? null,
    previous: data.previous ?? null,
  };
};

// Admin MTN Transactions
export const getAdminMtnTransactions = async (params = {}) => {
  const response = await axiosInstance.get(ADMIN_MTN_TRANSACTIONS, { params });
  const data = response.data;
  return {
    transactions: data.results ?? [],
    total: data.count ?? 0,
    summary: data.summary ?? {},
    next: data.next ?? null,
    previous: data.previous ?? null,
  };
};

// Admin All Transactions
export const getAdminAllTransactions = async (params = {}) => {
  const response = await axiosInstance.get(ADMIN_ALL_TRANSACTIONS, { params });
  const data = response.data;
  // According to user provided structure: { data: { results: ... }, meta: ... }
  // We need to access data.data for results, count, etc.
  const content = data.data || {};

  return {
    transactions: content.results ?? [],
    total: content.count ?? 0,
    summary: content.summary ?? {},
    next: content.next ?? null,
    previous: content.previous ?? null,
  };
};

// Admin Wallets
export const getAdminWallets = async (params = {}) => {
  const response = await axiosInstance.get(ADMIN_WALLETS, { params });
  const data = response.data;
  return {
    wallets: data.results ?? [],
    total: data.count ?? 0,
    next: data.next ?? null,
    previous: data.previous ?? null,
  };
};

// Admin Total Balances and Statistics
export const getAdminTotalBalances = async () => {
  const response = await axiosInstance.get(ADMIN_TOTAL_BALANCES);
  return response.data;
};

// Retry Syriatel Transaction
export const retrySyriatelTransaction = async (id) => {
  const response = await axiosInstance.post(RETRY_SYRIATEL_TRANSACTION(id));
  return response.data;
};

// Retry MTN Transaction
export const retryMtnTransaction = async (id) => {
  const response = await axiosInstance.post(RETRY_MTN_TRANSACTION(id));
  return response.data;
};

// Maintenance Mode Functions

// Get Maintenance Status (Public)
export const getMaintenanceStatus = async () => {
  // Normal axios for public endpoint
  const response = await axios.get(MAINTENANCE_STATUS);
  return response.data;
};

// Set Maintenance Mode (Protected)
export const setMaintenanceMode = async (isMaintenance) => {
  const response = await axiosInstance.post(MAINTENANCE_MODE, {
    is_maintenance: isMaintenance
  });
  return response.data;
};
